import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { ForgotPasswordForm } from '@/features/auth/components/ForgotPasswordForm';
import { Toaster } from 'sonner';

export function ForgotPassword() {
  const { session, isInitialized } = useAuthStore();

  if (isInitialized && session) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <ForgotPasswordForm />
      <Toaster position="top-right" />
    </div>
  );
}
